import { doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { getLiveDoc } from './liveData';

// Atölye listesi settings/global.atolyeler içinde tutulur: [{ id, name }]
// Atölye giderleri (expenses, type: 'atelier') atölyeye atolyeId ile bağlanır.
export const DEFAULT_ATOLYE_ID = 'varsayilan';

export const getAtolyeler = (settings) => {
  const list = Array.isArray(settings?.atolyeler) ? settings.atolyeler : [];
  return list
    .filter(a => a && a.id && (a.name || '').trim())
    .map(a => ({ id: a.id, name: a.name.trim() }));
};

export const fetchAtolyeler = async () => {
  const snap = await getLiveDoc('settings/global');
  return snap.exists() ? getAtolyeler(snap.data()) : [];
};

// Güncel listeyi okuyup değiştirerek yazar (başka ekrandan yapılan eklemeler ezilmesin)
export const updateAtolyeler = async (updater) => {
  const current = await fetchAtolyeler();
  const next = updater(current);
  await setDoc(doc(db, 'settings', 'global'), { atolyeler: next }, { merge: true });
  return next;
};
